import { VesselPosition } from '../../../../lib/vessels/registries/vessels.types';

export const filterVesselsByName = (
	vessels: VesselPosition[],
	name: string
): VesselPosition[] => vessels.filter(
	(vessel) => vessel.vessel.name.toLowerCase().includes(name)
);
